export function destroyExplosion(id) {
    return {
        type: "DESTROY_EXPLOSION",
        id
    };
}

export function createExplosion(explosionConfig) {
    return {
        type: "CREATE_EXPLOSION",
        explosionConfig
    };
}


// WEBPACK FOOTER //
// ./src/actions/explosions.js